import React from 'react'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import logo from '../assets/images/ems-home-services-logo-lg.png'

class Header extends React.Component {
    render() {
        return (
            <section id="header">
                <div className="inner">
                    <div className="image fit" style={{
                        maxWidth: 600,
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}>
                        <Img
                            className=""
                            sizes={this.props.headerImage.sizes}
                            alt="EMS Home Services, HVAC Services, Austin TX"
                        />
                    </div>
                    <h1>
                    Residential and Commercial HVAC <br/>
                        Services in Austin, TX <br/>
                    </h1>
                    <ul className="actions">
                        <li><Link to="#replace" className="button scrolly">Replace</Link></li>
                        <li><Link to="#repair" className="button scrolly">Repair</Link></li>
                        <li><Link to="#maintain" className="button scrolly">Maintain</Link></li>
                    </ul>


                </div>
            </section>
        )
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js